import { createAction, props } from '@ngrx/store';

const GET_LOGIN_METHOD = '[LoginMethod] Get LoginMethod';
const SET_LOGIN_METHOD = '[LoginMethod] Set LoginMethod';
const SENT_LOGIN_METHOD = '[LoginMethod] Sent LoginMethod';
const SAVE_LOGIN_METHOD = '[LoginMethod] Save LoginMethod';
const SENT_UPDATE_LOGIN_METHOD = '[LoginMethod] Sent Update LoginMethod';
const UPDATE_LOGIN_METHOD = '[LoginMethod] Update LoginMethod';
const DELETE_LOGIN_METHOD = '[LoginMethod] Delete LoginMethod';

const getLoginMethod = createAction(GET_LOGIN_METHOD, props<{ apiConstants: any; appId: any }>());
const setLoginMethod = createAction(SET_LOGIN_METHOD, props<{ loginMethodData: any }>());
const saveLoginMethod = createAction(SAVE_LOGIN_METHOD, props<{ loginMethodData: any }>());
const sentLoginMethod = createAction(SENT_LOGIN_METHOD, props<{ apiConstants: any; saveLoginMethodData: any }>());
const sentUpdateLoginMethod = createAction(
  SENT_UPDATE_LOGIN_METHOD,
  props<{ apiConstants: any; updateLoginMethodData: any }>()
);
const updateLoginMethod = createAction(UPDATE_LOGIN_METHOD, props<{ loginMethodData: any }>());

const deleteLoginMethod = createAction(DELETE_LOGIN_METHOD, props<{ loginMethodId: string }>());

export {
  getLoginMethod,
  setLoginMethod,
  sentLoginMethod,
  saveLoginMethod,
  sentUpdateLoginMethod,
  updateLoginMethod,
  deleteLoginMethod
};
